import Hero from "../components/Hero";
import Features from "../components/Features";
import WhyUs from "../components/WhyUs";
import Clients from "../components/Clients";
import Testimonials from "../components/Testimonials";
import Services from "../components/Services";
import CaseStudies from "../components/CaseStudies";


const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <WhyUs />
      <Services />
      <Clients />
      <CaseStudies />
      <Testimonials />

    </>
  );
};

export default Home;